<template>
  <div class="index">
      <div class="index-title">
        <div class="title">{{pageData.title}} <br />{{pageData.subtitle}}</div>
      </div>
      <div class="index-list" v-if="news.length>0">
        <div class="title">
          <img src="~@/assets/images/index-news.png" alt="">
        </div>
        <div class="index-list1">
          <newsList></newsList>
          <router-link class="more-news" to="/news">MORE</router-link>
        </div>
      </div>
      <div class="index-list">
        <div class="title title2">
          <img src="~@/assets/images/index-product.png" alt="">
        </div>
        <div class="index-list2">
          <div class="product-main">
            <ul>
              <li v-for="(item,index) in pageData.gamelist">
                <router-link class="" :to='"/productDetail?id="+ index'>
                  <img :src="require('../assets/images/list-img'+index+'.png')" alt="">
                  <div class="gameImgShadow">
                    <img :src="require('../assets/images/list-img'+index+'.png')" alt="">
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import 'swiper/dist/css/swiper.min.css';
  import Swiper from 'swiper';
  import newsList from '../components/newsList.vue';
  export default{
    data(){
      return{
        resDatas:'',
        num:5,
        heiAct:'index'
      }
    },
    components:{
      newsList
    },
    computed: {
      pageData() {
        return this.$store.state.languagesData.index;
      },
      news(){
        return this.$store.state.languagesData.news.newslist;
      }
    },
    props: {
        resData: {}
    },
    watch: {
        resData(newData){
          this.resDatas=newData;
        }
    },
    methods:{

    },
    mounted() {
      this.$store.commit("highLighted",this.$route.name);
      let swiper1 = new Swiper('.mySwiper', {
          slidesPerView: "auto",
          spaceBetween: 0,
          loop:true,
          centeredSlides: true,
          autoplay : {
            delay:3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
        this.$parent.getlan();
    }
  }
</script>

<style scoped>
  .index{
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  .index-title{
    background: url('~@/assets/images/index-bg.png') top center no-repeat;
    background-size:100% 100% ;
    padding: 15% 5%;
    box-sizing: border-box;
  }
  .index-title .title{
    font-size: 44px;
    font-weight: 700;
    text-align: center;
    color: white;
  }
  .index-list .title{
    margin-bottom: 3%;
  }
  .index-list .title img{
    width: 17%;
  }
  .index-list .title2 img{
    width: 20%;
  }
  .index-list{
  }
  .index-list1{
    border-top: 1px solid #ccc;
    margin-left: 8%;
  }
  .index-list1::after{
    content: '';
    display: block;
    clear: both;
  }
  .more-news{
    float: right;
    background-color: #536E7A;
    padding: 1% 2%;
    display: block;
    color: white;
    margin-top: 3%;
    cursor: pointer;
  }
  .index-list{
    max-width: 1000px;
    margin: auto;
    padding-top: 3%;
  }
  .product-main{
     margin-left: 8%;
  }
  .product-main ul{}
  .product-main ul::after{
    content: '';
    clear: both;
    display: block;
  }
  .product-main li{
    width: 45%;
    margin-bottom: 3%;
    position: relative;
    cursor: pointer;
  }
  .product-main li:nth-of-type(2n+1){
    float: left;
  }
  .product-main li:nth-of-type(2n+2){
    float: right;
  }
  .product-main li img{
    width: 100%;
    position: relative;
    z-index: 1;
  }
  .product-main .gameImgShadow{
    position: absolute;
    top: 0;
    left: 0;
    transition: all .3s ease-in-out;
    width: 100%;
    height: 100%;
    transform: translate(5px,5px);
    overflow: hidden;
    filter: blur(10px)
  }
  .product-main li:hover img{
    opacity: .8;
  }
  .product-main li:hover .gameImgShadow{
    opacity: 0;
  }
  .list-item{
    position: relative;
    background-color: white;
    overflow: hidden;
    border-radius: 5px;
  }
  .list-banner{
    position: relative;
    overflow: hidden;
  }
  .list-banner img{
    width: 100%;
    transition: all .3s;
  }
  .banner-title{
    position: absolute;
    height: 0;
    width: 100%;
    bottom: 0;
    background-color: rgba(0, 0, 0, .9);
    transition: all .3s;
    cursor: pointer;
  }
  .banner-title a{
    display: block;
    color: white;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
  }
  .game-icon{
    display: inline-block;
    width: 80px;
    position: relative;
    left: 50%;
    margin: auto;
    transform: translate(-50%,-50%);
    transition: all .3s;
  }
  .text-box{
    transform: translateY(-100%);
  }
  .text-box h3{
    font-size: 18px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    display: inline-block;
    transition: all .3s;
  }
  .text-box p{
    font-size: 14px;
    position: relative;
    display: inline-block;
    transition: all .3s;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    padding: 0 5%;
    box-sizing: border-box;
    text-align: center;
  }
  .list-item:hover .game-icon{
    left: 5%;
    transform: translate(0%,-50%);
  }
  .list-item:hover h3,.list-item:hover p{
    left: 5%;
    transform: translateX(0);
    padding: 0;
    padding-right: 10%;
    text-align: left;
  }

  .list-item:hover .banner-title{
    height: 50px;
  }
  .list-item:hover .list-banner img{
    transform: scale(1.1);
  }
  @media screen and (max-width: 1000px){
    .index{
      background-size: 100% 100%;
    }
    .index-title{
      padding: calc(15% + 70px) 5%;
    }
    .index-list{
      padding: 0 3%;
    }
    .index-list1{
      margin-left: 0;
    }
    .index-title .title{
        font-size: 24px;
    }
    .product-main{
      margin-left: 0;
    }
    .product-main li{
      width: 100%;
      padding: 0 3%;
      box-sizing: border-box;
      margin-top: 5%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue